import moment from 'moment';

export const formatDate = (value, variant) => (value ? moment(value).format(variant) : '-');
